function $b0230aa3b7b91386$export$2e2bcd8739ae039(array1, array2) {
    // error checks
    if (!Array.isArray(array1) || !Array.isArray(array2)) throw new Error("intersect() expected two arrays to compare.");
    let arraysDoIntersect = false;
    array2.forEach((item)=>{
        if (array1.includes(item)) arraysDoIntersect = true;
    });
    return arraysDoIntersect;
}


class $1caf79e2617fae57$export$2e2bcd8739ae039 {
    // dom elements
    buttons;
    listItems;
    // vars
    selectedTags = "featured";
    constructor(){}
    init() {
        // get dom elements
        this.buttons = document.getElementsByClassName("filter-button");
        this.listItems = document.getElementsByClassName("project-list-item");
        // event handlers
        const numButtons = this.buttons.length;
        for(let i = 0; i < numButtons; i++){
            const b = this.buttons[i];
            b.addEventListener("click", this.onFilterButtonClicked.bind(this));
        }
    }
    apply() {
        const showAll = this.selectedTags === "all";
        const numListItems = this.listItems.length;
        for(let i = 0; i < numListItems; i++){
            const item = this.listItems[i];
            if (showAll) item.dataset.visible = true;
            else {
                const filtersIntesect = (0, $b0230aa3b7b91386$export$2e2bcd8739ae039)(item.dataset.tags.split(","), this.selectedTags.split(","));
                item.dataset.visible = filtersIntesect;
            }
        }
    }
    onFilterButtonClicked(event) {
        const button = event.target;
        const isSelected = button.dataset.selected === true || button.dataset.selected === "true";
        // quick exit
        if (isSelected) return;
        // deselect all buttons
        const numButtons = this.buttons.length;
        for(let i = 0; i < numButtons; i++){
            const b = this.buttons[i];
            b.dataset.selected = false;
        }
        // apply filters
        button.dataset.selected = true;
        this.selectedTags = button.dataset.tags;
        this.apply();
    }
}


// vars
let $20e6394ad987cb11$var$filters;
// auto initialization
$20e6394ad987cb11$var$init();
function $20e6394ad987cb11$var$init() {
    if (PROJECT_TYPE === "art") {
        $20e6394ad987cb11$var$filters = new (0, $1caf79e2617fae57$export$2e2bcd8739ae039)();
        $20e6394ad987cb11$var$filters.init();
        $20e6394ad987cb11$var$filters.apply();
    }
}


//# sourceMappingURL=projects-index.js.map
